import * as api from '../api.js';
import { toTitleCase } from '#utils';

export const getOuting = async ({ slug }, set, get) => {
  const { success, failure } = await api.getOuting({
    slug,
  });
  if (failure) {
    return;
  }
  const { outing } = success;
  get().setOuting(outing || {});
};

export const getNearbyOutings = async (filters, set, get) => {
  const { success, failure } = await api.getNearbyOutings(filters);
  if (failure) {
    return;
  }
  const { outings } = success;
  get().setNearbyOutings(outings);
};

export const getStateOutings = async ({ state }, set, get) => {
  const { success, failure } = await api.getStateOutings({ state });
  if (failure) {
    return;
  }
  const { campgrounds, popularCampgrounds, areas, activities } = success;
  get().setStateOutings({
    campgrounds,
    popularCampgrounds,
    areas,
    activities,
  });
};

export const getOutingStats = async ({ outingId, entityKey }, set, get) => {
  const { success, failure } = await api.getOutingStats({
    outingId: outingId || get().outing._id,
    entityKey,
  });
  if (failure) {
    return;
  }
  const { successRate, cancellations, analytics } = success;

  // Build news object with cancellations if available
  const newsObj = {
    text: '',
    show: false,
    cancellations: cancellations || null,
    analytics: analytics || null,
  };

  if (successRate >= 60) {
    const outingName = cancellations?.outingName || toTitleCase(get().outing?.name || '')
      .split(' ')
      .slice(0, 2)
      .join(' ');
    newsObj.text = `${successRate}% success rate for ${outingName}!`;
    newsObj.show = true;
    newsObj.pages = ['landing'];
  }

  get().setNews(newsObj);
};

export const selectOuting = async (
  { selectedOuting, searchInput, name },
  set,
  get
) => {
  // Set the search input to the outing name
  get().setSearchInput(toTitleCase(name));
  // Set the current outing
  await get().setOuting(selectedOuting);
  // Get the percentage of success & cancellations
  get().getOutingStats({ outingId: selectedOuting._id });
  // Close the suggestion box
  get().setShowSuggestions(false);
  get().resetCampsitesFilter();
  // Drop any leftover multi-night trip draft so TrackerSummary / checkout
  // don't keep showing the previous trip after the user picks a normal outing.
  get().clearTripDraft();
  // Push the search event to the analytics
  get().putEvent({
    type: 'search',
    data: {
      query: searchInput,
      outingName: name,
      outingId: selectedOuting._id,
    },
  });
};
